import type { JSX } from "react";

import { GITHUB_URL, ISSUES_URL, RELEASES_URL } from "@/lib/site";

const linkClass = "rounded text-muted-foreground transition-colors hover:text-foreground";

export const SiteFooter = (): JSX.Element => (
  <footer className="mt-auto border-t border-border/60">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-5 gap-y-2 px-4 py-6 text-sm sm:px-6">
      <span className="text-muted-foreground">Open source, MIT licensed.</span>

      <div className="flex-1" />

      <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
        <a href={RELEASES_URL} target="_blank" rel="noreferrer noopener" className={linkClass}>
          Download
        </a>
        <a href={GITHUB_URL} target="_blank" rel="noreferrer noopener" className={linkClass}>
          Source
        </a>
        <a href={ISSUES_URL} target="_blank" rel="noreferrer noopener" className={linkClass}>
          Report an issue
        </a>
      </nav>
    </div>
  </footer>
);
